<div class="title-bar baseline">
  <h1>
    {{ "PRODUCTS.PRODUCTS" | translate }}
  </h1>
  <div
    [matTooltip]="'PRODUCTS.BTN.TOOLTIP' | translate"
    [matTooltipDisabled]="requiredMerchantDataFilled$ | async"
  >
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="add()"
      [disabled]="(requiredMerchantDataFilled$ | async) === false"
    >
      <mat-icon>add</mat-icon>
      {{ "PRODUCTS.BTN.ADD" | translate }}
    </button>
  </div>
</div>
<app-tabs name="products" [tabPanel]="tabPanel"></app-tabs>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
